import React from "react";

const ThankYouPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0e9bff, #3ac7ff)",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          color: "#333",
          padding: "50px 40px",
          borderRadius: "20px",
          width: "95%",
          maxWidth: "600px",
          textAlign: "center",
          boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
          animation: "fadeIn 1.2s ease",
        }}
      >
        <div style={{ fontSize: "3rem" }}>🎉</div>

        <h1 style={{ fontSize: "2.2rem", fontWeight: "700", marginTop: "15px" }}>
          Thank You for Submitting Your Details!
        </h1>

        <p
          style={{
            fontSize: "1.1rem",
            marginTop: "15px",
            lineHeight: "1.6",
            color: "#555",
          }}
        >
          We have successfully received your information.  
          Our dedicated support team is now reviewing your request.
        </p>

        <p
          style={{
            fontSize: "1.05rem",
            marginTop: "10px",
            color: "#666",
          }}
        >
          You will receive a confirmation call or message within  
          <strong> 24 to 72 hours.</strong>  
          Please keep your phone reachable.
        </p>

        <div
          style={{
            marginTop: "25px",
            padding: "15px",
            background: "#f0f8ff",
            borderRadius: "10px",
            color: "#0e9bff",
            fontSize: "0.95rem",
            fontWeight: "600",
            border: "1px solid #d6edff",
          }}
        >
          📌 *Note:* Our team may call from an official or alternate number.
          Kindly respond to avoid delays.
        </div>

        <button
          style={{
            marginTop: "35px",
            padding: "13px 35px",
            fontSize: "1rem",
            fontWeight: "bold",
            color: "#fff",
            background: "linear-gradient(135deg, #0e9bff, #3ac7ff)",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            boxShadow: "0 6px 20px rgba(14,155,255,0.4)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) =>
            (e.target.style.boxShadow = "0 8px 25px rgba(14,155,255,0.6)")
          }
          onMouseLeave={(e) =>
            (e.target.style.boxShadow = "0 6px 20px rgba(14,155,255,0.4)")
          }
          onClick={() => (window.location.href = "/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
